enum EOrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export default EOrderDirection;
